import Cookies from "js-cookie";
import { BACKEND_URL, getHeaders, handleResponse } from "./utils";
import { IRequestPatchUser, TVerify } from "../types/user";

export async function getUser() {
  try {
    const response = await fetch(`${BACKEND_URL}/users/me`, {
      method: "GET",
      headers: getHeaders(Cookies.get("accessToken")),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get user:", error);
    throw error;
  }
}

export async function getUsersFilters(query: string) {
  try {
    const response = await fetch(`${BACKEND_URL}/users/filter?${query}`, {
      method: "GET",
      headers: getHeaders(Cookies.get("accessToken")),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get users filters:", error);
    throw error;
  }
}

export async function getUserById(id: number) {
  try {
    const response = await fetch(`${BACKEND_URL}/users/${id}`, {
      method: "GET",
      headers: getHeaders(),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get user:", error);
    throw error;
  }
}

export async function getUsers() {
  try {
    const response = await fetch(`${BACKEND_URL}/users`, {
      method: "GET",
      headers: getHeaders(),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get users:", error);
    throw error;
  }
}

export async function patchUser(data: IRequestPatchUser) {
  try {
    const response = await fetch(`${BACKEND_URL}/users/me`, {
      method: "PATCH",
      headers: getHeaders(Cookies.get("accessToken")),
      body: JSON.stringify(data),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get user:", error);
    throw error;
  }
}

export async function deletePhoto(photos: { photoIds: number[] }) {
  try {
    const response = await fetch(`${BACKEND_URL}/gallery/delete`, {
      method: "DELETE",
      headers: getHeaders(Cookies.get("accessToken")),
      body: JSON.stringify(photos),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error delete photos:", error);
    throw error;
  }
}

//-------------------------ADMIN-------------------

export async function getModelsVerification() {
  try {
    const response = await fetch(`${BACKEND_URL}/users/verification-list`, {
      method: "GET",
      headers: getHeaders(Cookies.get("accessToken")),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get users:", error);
    throw error;
  }
}
export async function getModelsNotVerification() {
  try {
    const response = await fetch(
      `${BACKEND_URL}/users/not-verifications-list`,
      {
        method: "GET",
        headers: getHeaders(Cookies.get("accessToken")),
      },
    );

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get users:", error);
    throw error;
  }
}
export async function getModelsBan() {
  try {
    const response = await fetch(`${BACKEND_URL}/users/banned`, {
      method: "GET",
      headers: getHeaders(Cookies.get("accessToken")),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get users:", error);
    throw error;
  }
}
export async function getModelsDocument() {
  try {
    const response = await fetch(`${BACKEND_URL}/users/verificationsPhotos`, {
      method: "GET",
      headers: getHeaders(Cookies.get("accessToken")),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get users:", error);
    throw error;
  }
}

export async function setIsBanned(
  data: { isBanned: boolean; reason: string },
  id: number,
) {
  try {
    const response = await fetch(`${BACKEND_URL}/users/${id}/ban`, {
      method: "PATCH",
      headers: getHeaders(Cookies.get("accessToken")),
      body: JSON.stringify(data),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get user:", error);
    throw error;
  }
}

export async function setIsVerificate(
  data: { status: string; reason: string },
  id: number,
) {
  try {
    const response = await fetch(`${BACKEND_URL}/users/verify/${id}`, {
      method: "PATCH",
      headers: getHeaders(Cookies.get("accessToken")),
      body: JSON.stringify(data),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error get user:", error);
    throw error;
  }
}

//--------------------- CLIENT --------------------

export async function deleteAvatarClient() {
  try {
    const response = await fetch(`${BACKEND_URL}/profile-avatar/delete`, {
      method: "DELETE",
      headers: getHeaders(Cookies.get("accessToken")),
    });

    return await handleResponse(response);
  } catch (error) {
    console.error("Error delete clients avatar:", error);
    throw error;
  }
}
